import { NgIf } from '@angular/common';
import { FieldType, FormlyFieldProps } from '@ngx-formly/bootstrap/form-field';
import { FieldTypeConfig } from '@ngx-formly/core';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { TooltipComponent } from '../../../../../shared/component/tooltip/tooltip.component';

interface LabelProps extends FormlyFieldProps {
  tooltip?: string;
}

// noinspection CssUnknownTarget
@Component({
  selector: 'app-label-field',
  template: `
    <p class="small-label">
      {{ props.label | translate }}
      <app-tooltip
        *ngIf="props.tooltip"
        [tooltip]="props.tooltip"></app-tooltip>
    </p>
  `,
  styles: `
    p.small-label {
      display: flex;
      align-items: center;
      gap: 8px;
      font-size: 16px;
      font-weight: 400;
      color: var(--p-greyscale-300);
      margin-bottom: 8px;
    }
  `,
  imports: [TranslatePipe, TooltipComponent, NgIf],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SmallLabelFieldComponent extends FieldType<
  FieldTypeConfig<LabelProps>
> {}
